import { render, staticRenderFns } from "./vip-list.vue?vue&type=template&id=0695172e&scoped=true&"
import script from "./vip-list.vue?vue&type=script&lang=js&"
export * from "./vip-list.vue?vue&type=script&lang=js&"
import style0 from "./vip-list.vue?vue&type=style&index=0&id=0695172e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0695172e",
  null
  
)

export default component.exports